import { ANNO_TYPE_LAG, handleDataLag } from './dataLag';

// process annotations from MGW
// NOTE: There are cases where a lack of an annotation should trigger an action like clear.
// the relevant flag state can be maintained in an atom or zustand store to make this work

export const processAnnotations = (annotations) => {
  try {
    annotations.forEach((anno) => {
      switch (anno.type) {
        case ANNO_TYPE_LAG:
          handleDataLag(anno);
          break;
      }
    });
  } catch (err) {
    console.error('failed to process annotations');
  }
};
